import { render, staticRenderFns } from "./main.vue?vue&type=template&id=a3b7bf3a&scoped=true&"
import script from "./main.vue?vue&type=script&lang=js&"
export * from "./main.vue?vue&type=script&lang=js&"
import style0 from "./main.vue?vue&type=style&index=0&id=a3b7bf3a&prod&lang=less&scoped=true&"
import style1 from "./main.vue?vue&type=style&index=1&id=a3b7bf3a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3b7bf3a",
  null
  
)

export default component.exports